export default "__VITE_PUBLIC_ASSET__bc1bc030__"